import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cloneDeep, isEmpty, isNil, isNumber, orderBy, forEach } from 'lodash';
import { BehaviorSubject, forkJoin, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, finalize, flatMap, map, switchMap } from 'rxjs/operators';
import { TreatmentPlotComponent } from '../../../../shared/components/treatment-plot/treatment-plot.component';
import {
  ENUM_TREATMENT_TYPE, INPUT_DATA_KEY, INTERVAL_CHECK_WELL_INPROGRESS, TREATMENT_TYPE,
  ChartTimeFormat, TIME_SETTING_TYPE, TREATMENT_MONITOR_NUMBER, PREFIX_PREDICTIVE_CHANNEL, INTERVAL_CHART_REALTIME, INTERVAL_CHART_COMMENT_REALTIME, INTERVAL_CHART_CHANNEL_REALTIME, YAXIS_KEYS, WELL_TOKEN_EXPIRED, DEFAULT_MONITOR_LAST_MIN_FILTER
} from '../../../../shared/helpers/app.constants';
import { Helper } from '../../../../shared/helpers/helper';
import { IInputDataChart, IInputDataMultiFlow, ITimeSetting, ITreatmentComment } from '../../../../shared/models';
import { IChannelItem, IReatlimeChannelSettingModel as IRealTimeChannelSettingModel, IChannelSettingItemModel, IChannelSettingModel, IChannelMappingResponse } from '../../../../shared/models/channel.model';
import { ChannelMappingService, ChannelMappingStorageService, ChannelSelectionService, ChartsService, DiagnosticCompanyStorageService, DiagnosticPointsService, FracproChannelsService, FracproChannelStorageService, PlotTemplateService, RealtimeTreatmentStorageService } from '../../../../shared/services';
import { BaseChartService } from '../../../../shared/services/charts/base-chart.service';
import { RealtimeChartService } from '../../../../shared/services/charts/realtime-chart.service';
import { TreatmentService } from '../../../../shared/services/treatment.service';
import { UserAuthService } from '../../../../shared/services/user-auth.service';
import { UserRolesService } from '../../../../shared/services/user-roles.service';
import { IntervalTimer, TimerState } from '../../../../shared/helpers/intervalTimer';
import { ITreatmentItem } from '../../../../shared/models/treatment.model';
import { CompareWellsService } from '../../../../shared/services/compare-wells.service';
import { RealtimeTreatmentService } from './realtime-treatment.service';
import { TreatmentPlotService } from '../../../../shared/components/treatment-plot/treatment-plot.service';
import { IPlotTemplateResponse } from '../../../../shared/models/plot-template.model';
import { IDiagnosticPoint } from '../../../../shared/models/diagnostic-points.model';
import { ScrollbarChartSettingsService } from '../../../../shared/services/scrollbar-chart-settings.service';
import { UnitSystemService } from '../../../../shared/services/unit-system.service';
import { formatNumber } from '@angular/common';
import { SessionService } from '../../../../shared/services/session/session.service';
import { IBourdetOption } from '../../../../shared/models/offset-well-compare.model';


const CHANNEL_SETTINGS_KEY = 'realtimeChannelSettings';
const DIGITS_AFTER_DECIMAL_KEY = 'DigitsAfterDecimalConfig';
const OFFSET_CHANNEL_SETTINGS_KEY = 'realtimeOffsetChannelSettings';
const FILTER_SETTINGS_KEY = 'realtimeFilterSettings';
const FULLCHART_SETTINGS_KEY = 'realtimeFullchartSettings';
const DISPLAY_COMMENT_SETTINGS_KEY = 'realtimeDisplayCommentSettings';
const DATA_PANELS_KEY = 'realtimeDataPanel';
const DATA_SUMMARY_KEY = 'realtimeSummary';

export interface IRealtimeDataStateSetting {
  offsetChannelSetting: IChannelSettingModel;
  channelSetting: IChannelSettingModel;
  filterSetting: ITimeSetting;
  fullChartSetting: number;
  displayCommentSetting: number;
}

export enum CHART_VIEW_STATE {
  Normal = 0,
  FullChart = 1,
  DataPanel = 2
}

@Component({
  selector: 'app-realtime-treatment',
  templateUrl: './realtime-treatment.component.html',
  styleUrls: ['./realtime-treatment.component.scss']
})
export class RealtimeTreatmentComponent implements OnInit, OnDestroy {
  @ViewChild(TreatmentPlotComponent) treatmentPlot: TreatmentPlotComponent;
  @ViewChild(TreatmentPlotComponent) treatmentPlot2: TreatmentPlotComponent;
  @ViewChild(TreatmentPlotComponent) treatmentPlot3: TreatmentPlotComponent;

  @ViewChild('dataPanelRef') dataPanelRef: ElementRef;
  TREATMENT_MONITOR_NUMBER = TREATMENT_MONITOR_NUMBER;
  subscriptions: Subscription[] = [];
  isFieldEngineer: boolean = false;
  chartInputData: IInputDataMultiFlow;
  renderDataPanel: boolean = true;
  isLoadingChartData: boolean = true;
  timeFormat: ChartTimeFormat = TIME_SETTING_TYPE.OffsetTime;
  wellToken: string;

  realtimeTreatmentAPILoading: boolean = false;

  @Input() isPadRealtime: boolean;
  @Input() padName: string;
  queryParams: any = {
    wellId: '',
    treatmentId: ''
  };
  @Input()
  set setQueryParams(data) {
    if (!data || data.treatmentId === this.queryParams.treatmentId) return;
    this.queryParams = { wellId: data.wellId, treatmentId: data.treatmentId };

    this.uninitialize();
    this.initialize();
  }

  channelSettings: IChannelSettingModel[] = [];
  offsetChannelSettings: IChannelSettingModel[] = [];
  filterSettings: ITimeSetting[] = [];
  fullChartSettings: number[] = [];
  CHART_VIEW_STATE = CHART_VIEW_STATE;

  realtimeChannelSetting: IRealTimeChannelSettingModel;
  lastRequestDataTime: string;
  autoScaleTime: boolean = true;
  gridDataItems: any[] = [];
  dataPanelItems: any[] = [];
  wellInfo: any = {};
  intervalCheckRealtimeInprogress: IntervalTimer;
  fracproGridDataCName = [];
  listFlowpaths: any[] = [];
  selectedFlowpath: any[];
  wellTimeZoneOffset: number = null;
  flagKeys = ['isDisplayTooltip', 'isDisplayComment', 'showFullChart', 'timeFormat'];

  listDiagnosticPoints: IDiagnosticPoint[] = [];
  losPoints: IDiagnosticPoint[] = [];
  listTreatmentComments: ITreatmentComment[];
  isDisplayComment: boolean;
  displayCommentSetting: number[] = [];

  wellTokenStartTime: number = 0;
  wellTokenIntervalTimer: IntervalTimer;
  timeoutId: any;
  chartInputDataTimeoutId: any;
  intervalTimer: IntervalTimer;
  isReloadFracproDataChart: boolean;
  intervalTimerChannels: IntervalTimer;
  commentTimer: IntervalTimer;
  intervalId;
  showSummary = false;
  userCompanyId: number = null;
  isDataPanel2Col: boolean = false;
  treatmentInfo: ITreatmentItem;
  treatmentName: string = '';
  listWells;
  dataPanelCount: number = 0;
  startChartDataTime: string;
  isReloadDataChart: boolean;
  baseTreatmentDateTime: string;
  listRealtimeChannels: IChannelItem[] = [];
  listFracProChannels: IChannelItem[] = [];
  listPredictedChannels: IChannelItem[] = [];
  dataPlotTemplates: IPlotTemplateResponse[];
  channelMappingData: IChannelMappingResponse[] = [];
  requestInProgress = false;
  reloadInProgress = false;
  setPlotTemplate = false;
  fracProChannelsLatestVer: any[] = [];

  realtimeStateSettings: IRealtimeDataStateSetting[] = [];
  viewChangeEventSubject: Subject<void> = new Subject<void>();

  treatmentData$: BehaviorSubject<any> = new BehaviorSubject(null);
  isMonitoring$: Observable<boolean> = this.treatmentData$.asObservable().pipe(map(treatment => {
    if (treatment) {
      return treatment.number === TREATMENT_MONITOR_NUMBER || treatment.treatmentNumber === TREATMENT_MONITOR_NUMBER;
    }
    return false;
  }));

  _dialogOpened: boolean = false;
  @Input('dialogOpened')
  set dialogOpened(value: boolean) {
    if (this._dialogOpened !== value) {
      this._dialogOpened = !!value;
      this.dialogOpenedChange.emit(this.dialogOpened);
    }
  }
  get dialogOpened(): boolean {
    return this._dialogOpened;
  }
  @Output() dialogOpenedChange: EventEmitter<boolean> = new EventEmitter();

  @Output() isStopGettingChartData: EventEmitter<boolean> = new EventEmitter();
  @Output() timerStateChange: EventEmitter<TimerState> = new EventEmitter();

  constructor(
    private ngZone: NgZone,
    private route: ActivatedRoute,
    private router: Router,
    private treatmentService: TreatmentService,
    private treatmentPlotService: TreatmentPlotService,
    private scrollbarChartSettingsService: ScrollbarChartSettingsService,
    private channelMappingStorageService: ChannelMappingStorageService,
    private baseChartService: BaseChartService,
    private realtimeTreatmentService: RealtimeTreatmentService,
    private realtimeChartService: RealtimeChartService,
    private channelSelectionService: ChannelSelectionService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private realtimeTreatmentStorageService: RealtimeTreatmentStorageService,
    private compareWellsService: CompareWellsService,
    private channelMappingService: ChannelMappingService,
    private plotTemplateService: PlotTemplateService,
    private diagnosticPointsService: DiagnosticPointsService,
    private diagnosticCompanyStorageService: DiagnosticCompanyStorageService,
    private ref: ChangeDetectorRef,
    private fracproChannelStorageService: FracproChannelStorageService,
    private fracproChannelsService: FracproChannelsService,
    private unitSystemService: UnitSystemService,
    private sessionService: SessionService
  ) {
  }

  get flowPathType() {
    if (!this.listFlowpaths || !this.listFlowpaths[0]) return 0;
    return this.listFlowpaths[0].type;
  }

  ngOnInit() {
    const userInfo = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(userInfo);
    if (userRole.toLowerCase() === 'field engineer') {
      this.isFieldEngineer = true;
    }
    this.userCompanyId = userInfo.companyId || 0;
    // this.gridDataItems = this.realtimeChartService.getFracproGridDataDefault();
    this.gridDataItems = this.getGridDataItems(this.listFracProChannels, null, null);

    if (!this.isPadRealtime) {
      this.queryParams.treatmentId = Helper.parseInt(this.route.snapshot.params['treatmentId']);
      this.queryParams.wellId = Helper.parseInt(this.route.snapshot.queryParamMap.get('wellId'));
      this.initialize();
    }
  }

  private uninitialize() {
    this.listWells = [];
    this.dataPanelCount = 0;
    this.wellInfo = null;
    this.treatmentInfo = null;
    this.chartInputData = undefined;
    this.treatmentName = undefined;
    this.channelMappingData = [];
    this.fracProChannelsLatestVer = [];
    this.dataPlotTemplates = [];
    this.listFlowpaths = [];
    this.baseTreatmentDateTime = undefined;
    this.startChartDataTime = undefined;
    this.listDiagnosticPoints = [];
    this.listFracProChannels = [];
    this.listRealtimeChannels = [];
    this.listPredictedChannels = [];
    this.listTreatmentComments = [];
    this.gridDataItems = [];
    this.channelSettings = [];
    this.offsetChannelSettings = [];
    this.filterSettings = [];
    this.realtimeChannelSetting = undefined;
    this.requestInProgress = true;
    this.reloadInProgress = true;
    this.onDestroyInterval();
  }

  private initialize() {
    this.realtimeTreatmentAPILoading = true;
    const getWellNameList = this.compareWellsService.getListWellName();
    // const getWellInfo = this.treatmentService.getWellDetail(this.queryParams.wellId);
    const getTreatmentInfo = this.treatmentService.getTreatmentDetailWebApi(this.queryParams.wellId, this.queryParams.treatmentId);
    const getFlowPath = this.treatmentService.getListFlowPaths(this.queryParams.wellId, this.queryParams.treatmentId);
    const getTemplate = this.plotTemplateService.getByWell(this.queryParams.wellId);

    this.channelMappingData = this.channelMappingStorageService.getChannelMapped(this.userCompanyId) || [];
    const getChannelMapping = this.channelMappingData && this.channelMappingData.length ? of(true) : this.channelMappingService.getAll(this.userCompanyId);
    
    this.fracProChannelsLatestVer = this.fracproChannelStorageService.getFracproChannels() || [];
    const fracProChannelsLatestVer$ = this.fracProChannelsLatestVer && this.fracProChannelsLatestVer.length ? of(true) : this.fracproChannelsService.getLatestVersion();
    
    const wellTreatmentsToken$ = this.sessionService.getWellTreatmentsToken(this.queryParams.wellId, this.queryParams.treatmentId);

    forkJoin([getWellNameList, getTreatmentInfo, getFlowPath, getTemplate, getChannelMapping, fracProChannelsLatestVer$, wellTreatmentsToken$]).pipe(switchMap(res => {
      this.listWells = res[0].result;
      this.treatmentInfo = res[1].result;
      if (res[1].result) {
        this.wellInfo = {
          wellId: this.queryParams.wellId,
          wellName: res[1].result.wellName,
          wellAPI: res[1].result.wellAPI,
          serviceCompany: res[1].result.serviceCompany,
          operatorCompany: res[1].result.operatorCompany,
          country: res[1].result.country,
          timeZone: res[1].result.timeZone,
          tzTimeZone: res[1].result.tzTimeZone,
          stTimeZone: res[1].result.stTimeZone,
          wellClosePres: res[1].result.wellClosePres,
          wellDiagnostics: res[1].result.wellDiagnostics,
          wellOpenTime: res[1].result.wellOpenTime,
          wellheadOpeningPressure: res[1].result.wellheadOpeningPressure
        };
        if (!this.wellInfo.tzTimeZone) this.wellInfo.tzTimeZone = Helper.lookupTimeZone(this.wellInfo.country, this.wellInfo.timeZone);
      }
      this.treatmentData$.next(this.treatmentInfo);
      this.listFlowpaths = res[2].result;
      this.dataPlotTemplates = res[3].result;
      this.baseTreatmentDateTime = Helper.toDateTimeString(this.treatmentInfo.baseTreatmentDateTime * 1000);
      this.setupTreatmentName();

      // map channelMappingData and cached it if result is NOT true
      if (res[4] && res[4].result) {
        this.channelMappingData = res[4].result.sort((a, b) => a > b);
        this.channelMappingStorageService.setChannelMapped(this.userCompanyId, this.channelMappingData);
      }
      // set fracpro Channels and cached it from Latest Version
      if (res[5] && res[5].result) {
        this.fracProChannelsLatestVer = res[5].result;
        this.fracproChannelStorageService.setFracproChannels(this.fracProChannelsLatestVer);
      }
      // set auth token for treatments_getChartData
      if (res[6]) {
        this.wellTokenStartTime = new Date().getTime();
        this.wellToken = res[6].result;
      }

      return this.getListDiagnosticPoints();
    })).pipe(switchMap((res) => {
      const pivotPoints = !res ? [] : res;
      this.listDiagnosticPoints = pivotPoints.filter(point => point.name !== 'MinMaxStart' && point.name !== 'MinMaxEnd');
      this.losPoints = pivotPoints.filter(point => point.name === 'MinMaxStart' || point.name === 'MinMaxEnd');
      const isMonitor = (this.treatmentInfo && this.treatmentInfo.number === TREATMENT_MONITOR_NUMBER);
      return this.treatmentService.getChannelsForSettings(this.queryParams.wellId, this.queryParams.treatmentId, this.flowPathType, isMonitor);
    })).pipe(switchMap(res => {
      this.listFracProChannels = res.fracProChannels;
      this.listRealtimeChannels = res.realtimeChannels;
      const filterPredictedChannel = x => x.originalName.toLowerCase().substring(0, PREFIX_PREDICTIVE_CHANNEL.length) === PREFIX_PREDICTIVE_CHANNEL;
      this.listPredictedChannels = res.realtimeChannels.filter(x => filterPredictedChannel(x));
      return of([]);
    }))
    .pipe(switchMap(data => {
      this.setUpShowSummary();
      this.setUpDataPanel();
      this.setUpChannelSettings();
      this.setUpOffsetChannelSettings();
      this.setUpFilterSettings();
      this.startChartDataTime = this.getStartChartDataTime(this.treatmentInfo, this.filterSettings);
      this.setUpRealtimeChannelSetting();
      this.setUpFullChartSettings();
      this.setUpDisplayCommentSetting();
      this.setUpRealtimeStateSetting();
      this.setUpGridData(true);
      return this.getTreatmentComments(this.queryParams.wellId, this.queryParams.treatmentId)
    }))
      .pipe(finalize(() => {
        this.isLoadingChartData = false;
        this.requestInProgress = false;
        this.reloadInProgress = false;
        if (!this.wellToken) {
          this.wellTokenStartTime = new Date().getTime();
          this.getWellTreatmentToken();
        }
        // run first time then run after interval
        this.chartInputDataTimeoutId = setTimeout(() => this.setUpChartInputData(), 100);
        this.timeoutId = setTimeout(() => this.runIntervalTimer(), 100);
        this.realtimeTreatmentAPILoading = false;
      }))
      .subscribe((treatmentComments) => {
        if (!isEmpty(treatmentComments)) {
          this.listTreatmentComments = treatmentComments;
        }
      });
  }

  private getListDiagnosticPoints(): Observable<IDiagnosticPoint[]> {
    const companyId = this.userCompanyId || '';
    const companyStorage = this.diagnosticCompanyStorageService.getCompanyStorage(companyId);
    let companyDiagnostics: any;
    let companyDiagnostic$: Observable<any>;
    if (companyStorage) {
      companyDiagnostics = this.getCompanyDiagnostics(companyStorage);
      companyDiagnostic$ = of(Object.values(companyDiagnostics));
    } else {
      companyDiagnostic$ = this.diagnosticPointsService.getByCompany(companyId)
        .pipe(
          map(data => {
            this.diagnosticCompanyStorageService.setCompanyStorage(companyId, data.result);
            companyDiagnostics = this.getCompanyDiagnostics(data.result);
            return companyDiagnostics;
          })
        );
    }

    return companyDiagnostic$.pipe(
      switchMap(companyDiagnostics => {
        const paramNames = companyDiagnostics ? companyDiagnostics.map(item => item.name) : [];

        return this.diagnosticPointsService.getDataForPivotPoints(this.queryParams.treatmentId, paramNames, this.userCompanyId)
          .pipe(switchMap(pivotPoints => {
            const result = cloneDeep(pivotPoints);
            if (companyDiagnostics) {
              forEach(companyDiagnostics, (point) => {
                if (pivotPoints.findIndex(x => x.id === point.id) === -1) result.push(point);
              });
            }
            return of(result);
          }))
      })
    );
  }

  private getCompanyDiagnostics(companyDiagnostics) {
    const filterDiagnostic = diagnostic => {
      if (!diagnostic || !this.wellInfo || !this.wellInfo.diagnostics) return false;
      for (const wellDiagnostic of this.wellInfo.diagnostics) {
        if (wellDiagnostic.toString() === diagnostic.id.toString()) return true;
      }
      return false;
    };

    return companyDiagnostics
      .filter(x => filterDiagnostic(x))
      .map(x => {
        x.id = `${x.id}`;
        x.isDefault = false;
        return x;
      });
  }

  private runIntervalTimer(): void {
    const realtimeRequestRate = this.scrollbarChartSettingsService.getRealtimeRequestRate(this.userCompanyId) || INTERVAL_CHART_REALTIME;
    const currentTime = new Date().getTime();
    const wellTokenInterval = WELL_TOKEN_EXPIRED - (currentTime - this.wellTokenStartTime);
    this.ngZone.runOutsideAngular(() => {
      this.wellTokenIntervalTimer = new IntervalTimer(() => { this.getWellTreatmentToken(); }, wellTokenInterval);
      this.intervalTimer = new IntervalTimer(
        () => {
          if (this.realtimeChannelSetting && this.realtimeChannelSetting.cNames && this.realtimeChannelSetting.cNames.length) {
            this.setUpChartInputData()
          }
        }, realtimeRequestRate
      );
      this.intervalTimerChannels = new IntervalTimer(
        () => {
          let flagNames: string[] = [];
          const request$: any[] = [];
          // realtime-channels empty
          if (!this.listRealtimeChannels || !this.listRealtimeChannels.length) {
            flagNames.push('realtimeChannels');
            request$.push(
              this.treatmentService.getRealtimeChannels(this.queryParams.wellId, this.queryParams.treatmentId).pipe(catchError(err => of({})))
            )
          }
          // fracpro-channels empty
          const isReloadFracproChannels = () => {
            if (this.treatmentInfo && this.treatmentInfo.number === TREATMENT_MONITOR_NUMBER) return false;
            if (!this.listFracProChannels || !this.listFracProChannels.length) return true;
            if (!!this.isReloadFracproDataChart) return false;
            if (!this.chartInputData || !this.chartInputData.fracproData || !this.chartInputData.fracproData.length) return true;
            return false;
          }
          if (isReloadFracproChannels() === true) {
            flagNames.push('fracProChannels');
            request$.push(
              this.treatmentService.getFracProChannels(this.queryParams.wellId, this.queryParams.treatmentId, this.flowPathType).pipe(catchError(err => of({})))
            )
          }
          // reload channels data
          if (request$.length > 0) {
            forkJoin(request$)
              .subscribe(response => {
                this.ngZone.run(() => {
                  if (response && response.length) {
                    let flag = 0;
                    // get channels data
                    flagNames.forEach((name, key) => {
                      if (name === 'fracProChannels') {
                        if (response[key] && response[key].result.length) {
                          this.requestInProgress = true;
                          this.listFracProChannels = response[key].result;
                          if (this.realtimeChannelSetting) this.realtimeChannelSetting.cNames = this.listFracProChannels.map(x => x.cName);
                          flag++;
                        }
                      }
                      if (name === 'realtimeChannels') {
                        if (response[key] && response[key].result.items.length) {
                          this.requestInProgress = true;
                          this.listRealtimeChannels = response[key].result.items;
                          if (this.listRealtimeChannels.length) flag++;
                          const filterPredictedChannel = x => x.originalName.toLowerCase().substring(0, PREFIX_PREDICTIVE_CHANNEL.length) === PREFIX_PREDICTIVE_CHANNEL;
                          this.listPredictedChannels = this.listRealtimeChannels.filter(x => filterPredictedChannel(x));
                          flag++;
                        }
                      }
                    });
                    // set update chart data
                    if (flag > 0) {
                      this.requestInProgress = false;
                      if (this.realtimeChannelSetting) this.realtimeChannelSetting.lastDataTime = this.startChartDataTime;
                      this.setUpRealtimeChannelSetting();
                      if (this.realtimeChannelSetting && this.realtimeChannelSetting.cNames && this.realtimeChannelSetting.cNames.length) {
                        this.setUpChartInputData();
                      }
                    }
                  }
                });
              });
          }
        }, INTERVAL_CHART_CHANNEL_REALTIME
      );
      // interval update list comments
      // monitor treatment do NOT have comment
      this.commentTimer = new IntervalTimer(() => {
        if (this.displayCommentSetting.findIndex(x => x === 1) > -1 && this.queryParams && this.queryParams.wellId && this.queryParams.treatmentId) {
          this.loadTreatmentComments(this.queryParams.wellId, this.queryParams.treatmentId);
        }
      }, INTERVAL_CHART_COMMENT_REALTIME);
    });
  }

  private getWellTreatmentToken(): void {
    // wellToken
    this.subscriptions.push(
      this.sessionService.getWellTreatmentsToken(this.queryParams.wellId, this.queryParams.treatmentId)
        .subscribe(
          response => { if (response) this.wellToken = response.result; },
          error => { this.wellToken = undefined; }
        )
    );
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutId);
    clearTimeout(this.chartInputDataTimeoutId);
    this.onDestroyInterval();
    // clearInterval(this.intervalId);
    Helper.unsubscribe(this.subscriptions);
  }

  private setupTreatmentName = () => {
    if (!this.treatmentInfo) return;
    if (TREATMENT_TYPE[this.treatmentInfo.dataType] !== ENUM_TREATMENT_TYPE.Monitoring) {
      this.treatmentName = this.treatmentInfo.number === TREATMENT_MONITOR_NUMBER ? 'Monitoring' : `${TREATMENT_TYPE[this.treatmentInfo.dataType]} ${this.treatmentInfo.number}`;
    } else {
      this.treatmentName = `${TREATMENT_TYPE[this.treatmentInfo.dataType]}`;
    }
  }

  private setUpShowSummary = () => {
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, DATA_SUMMARY_KEY);
    this.showSummary = storage === false ? false : true;
  }

  private setUpDataPanel = () => {
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, DATA_PANELS_KEY);
    this.dataPanelCount = storage || 1;
  }

  private setUpChannelSettings = () => {
    const defaultSetting = this.channelSelectionService.getDefaultSettings(undefined, undefined, true);
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, CHANNEL_SETTINGS_KEY);
    if (!storage || !storage.length) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.channelSettings[i] = cloneDeep(defaultSetting);
      }
    } else {
      const handleChannelSetting = (channelSettings, realtimeList: any[], fracproList: any[]) => {
        if (isEmpty(realtimeList) && isEmpty(fracproList)) return defaultSetting;
        if (!channelSettings) return defaultSetting;

        const settings = cloneDeep(channelSettings);
        YAXIS_KEYS.forEach(key => {
          if (settings.hasOwnProperty(key)) {
            if (settings[key] && !isEmpty(settings[key].channels)) {
              settings[key].channels = settings[key].channels.map(channel => {
                let channelName: string = channel.channelName || channel.name;
                let cName: string = channel.cName;
                if (!channelName) {
                  if (!channel.channel || !channel.channel.name) return null;
                  channelName = channel.channel.name;
                }
                if (!cName && channel.channel) cName = channel.channel.cName;

                let channelExist = realtimeList.find(item => item.name === channelName && cName.indexOf('C') === 0);
                if (!channelExist) channelExist = fracproList.find(item => item.name === channelName && cName.indexOf('F') === 0);
                if (!channelExist) return null;

                channel.channelName = channelExist.name;
                channel.name = channelExist.name;
                channel.cName = channelExist.cName;
                channel.originalName = channelExist.originalName;
                channel.unit = channelExist.unit;
                channel.measureType = channelExist.measureType;
                if (channel.channel) {
                  channel.channel.name = channelExist.name;
                  channel.channel.cName = channelExist.cName;
                  channel.channel.originalName = channelExist.originalName;
                  channel.channel.unit = channelExist.unit;
                  channel.channel.measureType = channelExist.measureType;
                }
                return channel;
              }).filter(channel => channel !== null);
            } else {
              settings[key] = defaultSetting[key];
            }
          }
        });
        return settings;
      }
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.channelSettings[i] = handleChannelSetting(storage[i], this.listRealtimeChannels, this.listFracProChannels);
      }
    }
  }

  private setUpOffsetChannelSettings = () => {
    const defaultSetting = this.channelSelectionService.getDefaultSettings(undefined, undefined, true);
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, OFFSET_CHANNEL_SETTINGS_KEY);
    if (!storage || !storage.length) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.offsetChannelSettings[i] = cloneDeep(defaultSetting);
      }
    } else {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.offsetChannelSettings[i] = storage[i] || cloneDeep(defaultSetting);
      }
    }
  }

  private defaultFilterSetting = (): ITimeSetting => {
    const lastMin = this.treatmentInfo && this.treatmentInfo.number === TREATMENT_MONITOR_NUMBER ? DEFAULT_MONITOR_LAST_MIN_FILTER : 0;
    return {
      type: this.timeFormat,
      startIndex: 0,
      endIndex: 0,
      lastMin: lastMin,
      autoScale: true
    };
  }

  private setUpFilterSettings = () => {
    const defaultSetting = this.defaultFilterSetting();
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, FILTER_SETTINGS_KEY);
    if (!storage || !storage.length) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.filterSettings[i] = cloneDeep(defaultSetting);
      }
    } else {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.filterSettings[i] = storage[i] || cloneDeep(defaultSetting);
      }
    }
  }

  private setUpFullChartSettings = () => {
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, FULLCHART_SETTINGS_KEY);
    if (!storage || !storage.length) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.fullChartSettings[i] = !i ? CHART_VIEW_STATE.FullChart : CHART_VIEW_STATE.Normal;
      }
    } else {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.fullChartSettings[i] = storage[i];
      }
    }
  }

  private setUpDisplayCommentSetting = () => {
    const storage = this.realtimeTreatmentStorageService.getOption(this.queryParams.wellId, DISPLAY_COMMENT_SETTINGS_KEY);
    if (!storage || !storage.length) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.displayCommentSetting[i] = !i ? 1 : 0;
      }
    } else {
      for (let i = 0; i < this.dataPanelCount; i++) {
        this.displayCommentSetting[i] = storage[i];
      }
    }
  }

  private getStartChartDataTime = (treatment: ITreatmentItem, filterSetting: ITimeSetting[]): string => {
    if (!treatment) return undefined;
    const baseTime = treatment.baseTreatmentDateTime;
    const timeEnd = treatment.timeEnd || 0;
    if (treatment.number !== TREATMENT_MONITOR_NUMBER || !timeEnd) return Helper.toDateTimeString(baseTime * 1000);
    const timeStart = treatment.timeStart || 0;
    let lastMinFilter: number = 0;
    if (filterSetting && filterSetting.length) {
      for (const data of filterSetting) {
        if (!data) continue;
        if (!data.lastMin) {
          lastMinFilter = 0;
          break;
        }
        if (data.lastMin > lastMinFilter) lastMinFilter = data.lastMin;
      }
    } else lastMinFilter = DEFAULT_MONITOR_LAST_MIN_FILTER;

    if (!lastMinFilter) return Helper.toDateTimeString(baseTime * 1000);
    const tmpTime = timeEnd - lastMinFilter * 60;
    if (tmpTime >= timeStart) return Helper.toDateTimeString(tmpTime * 1000);
    else if (timeStart >= baseTime) return Helper.toDateTimeString(timeStart * 1000);
    else return Helper.toDateTimeString(baseTime * 1000);
  }

  private setUpRealtimeChannelSetting = () => {
    const res: IRealTimeChannelSettingModel = this.realtimeChannelSetting || {
      wellId: this.queryParams.wellId,
      treatmentId: this.queryParams.treatmentId,
      flowPathType: this.flowPathType,
      cNames: this.listFracProChannels.map(x => x.cName),
      lastDataTime: this.startChartDataTime
    };

    // for each cName selected from each channelSettings: push to realtimeChannelSetting.items if NOT exists
    for (const setting of this.channelSettings) {
      const channels = this.channelSelectionService.toChannelItems(setting);
      for (const ch of channels) {
        const find = res.cNames.find(x => x === ch.cName);
        if (!find) res.cNames.push(ch.cName);
      }
    }

    // compare if res.items equal to current realtimeChannelSetting.items
    // if there is a change: better load all data from begining
    if (this.realtimeChannelSetting) {
      const compareChannels = Helper.compareList(this.realtimeChannelSetting.cNames, res.cNames, false);
      if (compareChannels) res.lastDataTime = this.startChartDataTime;
    }

    this.realtimeChannelSetting = res;
  }

  private setUpRealtimeStateSetting(index?: number) {
    if (isNil(index)) {
      for (let i = 0; i < this.dataPanelCount; i++) {
        const res: IRealtimeDataStateSetting = {
          offsetChannelSetting: this.offsetChannelSettings[i],
          channelSetting: this.channelSettings[i],
          filterSetting: this.filterSettings[i],
          fullChartSetting: this.fullChartSettings[i],
          displayCommentSetting: this.displayCommentSetting[i]
        };
        this.realtimeStateSettings[i] = res;
      }
    } else {
      const res: IRealtimeDataStateSetting = {
        offsetChannelSetting: this.offsetChannelSettings[index],
        channelSetting: this.channelSettings[index],
        filterSetting: this.filterSettings[index],
        fullChartSetting: this.fullChartSettings[index],
        displayCommentSetting: this.displayCommentSetting[index]
      };
      this.realtimeStateSettings[index] = res;
    }
    this.realtimeStateSettings = cloneDeep(this.realtimeStateSettings);
  }

  private setUpChartInputData = () => {
    if (this.requestInProgress === true || !this.realtimeChannelSetting) return;
    this.requestInProgress = true;

    const { wellId, treatmentId, cNames, flowPathType, lastDataTime } = this.realtimeChannelSetting;
    let requestDataTime: string;
    if (this.isReloadDataChart) requestDataTime = this.startChartDataTime;
    else {
      requestDataTime = lastDataTime === this.startChartDataTime ? lastDataTime : Helper.concatTimeString(this.realtimeChannelSetting.lastDataTime, 1);
    }
    if (this.lastRequestDataTime !== requestDataTime) {
      this.lastRequestDataTime = requestDataTime;
      this.isStopGettingChartData.emit(false);
    } else {
      this.isStopGettingChartData.emit(true);
    }

    const nullChartData = of({ equipmentData: null, fracproData: [], realtimeData: [] });
    const getChartData = cNames.length ? this.treatmentPlotService.getChartData(wellId, treatmentId, cNames, cNames, null, flowPathType, this.treatmentInfo.isSeparateRealTimeData, requestDataTime, undefined, undefined, this.wellToken) : nullChartData;

    getChartData.subscribe(res => {
      this.ngZone.run(() => {
        if (this.reloadInProgress) return;
        // update treatment plot
        if (this.isReloadDataChart) this.chartInputData = res;
        else this.chartInputData = this.realtimeTreatmentService.concatRealtimeData(this.chartInputData, res, this.startChartDataTime, requestDataTime);
        // this.chartInputData = this.realtimeTreatmentService.concatRealtimeData(this.chartInputData, res, this.startChartDataTime, requestDataTime);
        if (this.chartInputData && this.chartInputData.fracproData && this.chartInputData.fracproData.length) this.isReloadFracproDataChart = true;
        // update lastDateTime for next data request
        const lastDateTime = this.treatmentPlotService.getLastTimeFromData(this.chartInputData, this.listPredictedChannels);
        if (lastDateTime && this.realtimeChannelSetting) this.realtimeChannelSetting.lastDataTime = lastDateTime;
        this.setUpGridData(this.isReloadDataChart);
        this.isReloadDataChart = false;
      });
    }, errors => {
      if (errors && errors.error) {
        // TOKEN_EXPIRED_REVOKED = 86, TOKEN_INVALID = 87 =>: reload token
        if (errors.error.code === 86 || errors.error.code === 87) this.getWellTreatmentToken();
        // IP_ACCESS_WELL_DENIED => return home page
        if (errors.error.code === 63) this.router.navigate(['pages/dashboard']);
      }
      this.requestInProgress = false;
    }, () => {
      this.requestInProgress = false;
    });
  }

  private setUpGridData(firstRun?: boolean) {
    const predictedCNames = this.listPredictedChannels.map(x => x.cName);
    const gridData = this.realtimeChartService.getFracproGridData(this.listFracProChannels);
    if (gridData && this.chartInputData && !firstRun) {
      this.realtimeChartService.setChannelValueGridData(gridData, this.chartInputData.fracproData[0], this.chartInputData.realtimeData[0], predictedCNames);
    }
    this.gridDataItems = gridData;
  }

  onChangeChannelSetting(data: IChannelSettingModel, index: number) {
    this.channelSettings[index] = data;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, CHANNEL_SETTINGS_KEY, this.channelSettings);
    this.channelSettings = cloneDeep(this.channelSettings);
    this.setUpRealtimeChannelSetting();
    this.setUpRealtimeStateSetting(index);
  }

  onChangeOffsetChannelSetting(data: IChannelSettingModel, index: number): void {
    this.offsetChannelSettings[index] = data;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, OFFSET_CHANNEL_SETTINGS_KEY, this.offsetChannelSettings);
    this.offsetChannelSettings = cloneDeep(this.offsetChannelSettings);
    this.setUpRealtimeStateSetting(index);
  }

  private checkReloadDataChart = (): void => {
    const startDataTime = this.getStartChartDataTime(this.treatmentInfo, this.filterSettings);
    this.isReloadDataChart = (startDataTime < this.startChartDataTime);
    if (this.isReloadDataChart) {
      this.startChartDataTime = startDataTime;
      this.lastRequestDataTime = undefined;
      if (this.realtimeChannelSetting) this.realtimeChannelSetting.lastDataTime = startDataTime;
    }
  }

  onChangeFilterSetting(data: ITimeSetting, index: number) {
    this.filterSettings[index] = data;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, FILTER_SETTINGS_KEY, this.filterSettings);
    this.filterSettings = cloneDeep(this.filterSettings);
    this.checkReloadDataChart();
    this.setUpRealtimeStateSetting(index);
  }

  onToggleFullChart(data: number, index: number) {
    this.fullChartSettings[index] = data;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, FULLCHART_SETTINGS_KEY, this.fullChartSettings);
    this.fullChartSettings = cloneDeep(this.fullChartSettings);
    this.setUpRealtimeStateSetting(index);
  }

  onToggleDisplayComment(data: number, index: number) {
    this.displayCommentSetting[index] = data;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, DISPLAY_COMMENT_SETTINGS_KEY, this.displayCommentSetting);
    this.displayCommentSetting = cloneDeep(this.displayCommentSetting);
    this.setUpRealtimeStateSetting(index);
  }

  onAddDataPanel(fullChart: number) {
    this.dataPanelCount = this.dataPanelCount + 1;

    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, DATA_PANELS_KEY, this.dataPanelCount);
    const channelSetting = this.channelSelectionService.getDefaultSettings(true, true); // cloneDeep(this.channelSettings[0]);
    this.onChangeChannelSetting(channelSetting, this.dataPanelCount - 1);
    const offsetChannelSetting = this.channelSelectionService.getDefaultSettings(true, true);
    this.onChangeOffsetChannelSetting(offsetChannelSetting, this.dataPanelCount - 1);
    const filterSetting = this.defaultFilterSetting(); // cloneDeep(this.filterSettings[0]);
    this.onChangeFilterSetting(filterSetting, this.dataPanelCount - 1);
    this.onToggleFullChart(fullChart, this.dataPanelCount - 1);
    this.onToggleDisplayComment(fullChart, this.dataPanelCount - 1);
    this.setUpRealtimeStateSetting();
    if (this.dataPanelCount === 2) setTimeout(() => this.viewChangeEventSubject.next(), 100);
  }

  onRemoveDataPanel() {
    if (this.dataPanelCount === 1) return;
    this.dataPanelCount = this.dataPanelCount - 1;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, DATA_PANELS_KEY, this.dataPanelCount);

    this.channelSettings.pop();
    this.realtimeTreatmentStorageService.popOption(this.queryParams.wellId, CHANNEL_SETTINGS_KEY);
    this.offsetChannelSettings.pop();
    this.realtimeTreatmentStorageService.popOption(this.queryParams.wellId, OFFSET_CHANNEL_SETTINGS_KEY);
    this.filterSettings.pop();
    this.realtimeTreatmentStorageService.popOption(this.queryParams.wellId, FILTER_SETTINGS_KEY);
    this.fullChartSettings.pop();
    this.realtimeTreatmentStorageService.popOption(this.queryParams.wellId, FULLCHART_SETTINGS_KEY);
    this.displayCommentSetting.pop()
    this.realtimeTreatmentStorageService.popOption(this.queryParams.wellId, DISPLAY_COMMENT_SETTINGS_KEY);
    this.setUpRealtimeStateSetting();

    // reload chart view if there is only one left
    if (this.dataPanelCount === 1) setTimeout(() => this.viewChangeEventSubject.next(), 100);
  }

  onCloseComponent(data: boolean, index: number) {
    // if index is the last
    if (index === this.dataPanelCount - 1) return this.onRemoveDataPanel();
    // else shift left
    for (let i = index; i < this.dataPanelCount - 1; i++) {
      this.onChangeChannelSetting(this.channelSettings[i + 1], i);
      this.onChangeOffsetChannelSetting(this.offsetChannelSettings[i + 1], i);
      this.onChangeFilterSetting(this.filterSettings[i + 1], i);
      this.onToggleFullChart(this.fullChartSettings[i + 1], i);
      this.onToggleDisplayComment(this.displayCommentSetting[i + 1], i);
    }
    this.onRemoveDataPanel();
    this.checkReloadDataChart();
    this.setUpRealtimeChannelSetting();
    this.setUpRealtimeStateSetting();
  }

  onTransformComponent(data: boolean, index: number) {
    if (!this.fullChartSettings) return;

    const currentForm = this.fullChartSettings[index];
    let nextForm: number = currentForm;
    // Plot panels: Multiple plot panels are allowed.
    // Do NOT allow transform to CHART_VIEW_STATE.DataPanel if there is only 1 chart panel
    if (currentForm !== CHART_VIEW_STATE.DataPanel && this.dataPanelCount === 1) return;
    if (currentForm === CHART_VIEW_STATE.DataPanel) nextForm = CHART_VIEW_STATE.Normal;
    // Data panel: Only one such panel is allowed
    else if (this.fullChartSettings.indexOf(CHART_VIEW_STATE.DataPanel) === -1) nextForm = CHART_VIEW_STATE.DataPanel;

    if (currentForm !== nextForm) this.onToggleFullChart(nextForm, index);
  }

  isDataPanelViewExist(): boolean {
    return this.fullChartSettings.indexOf(CHART_VIEW_STATE.DataPanel) > -1;
  }

  onToggleSummary() {
    this.showSummary = !this.showSummary;
    this.realtimeTreatmentStorageService.setOption(this.queryParams.wellId, DATA_SUMMARY_KEY, this.showSummary);
  }

  onUpdateInterval(resume = true): void {
    if (this.intervalTimer) {
      if (!resume) this.intervalTimer.pause();
      else this.intervalTimer.resume();
    }
    if (this.intervalTimerChannels) {
      if (!resume) this.intervalTimerChannels.pause();
      else this.intervalTimerChannels.resume();
    }
    if (this.commentTimer) {
      if (!resume) this.commentTimer.pause();
      else this.commentTimer.resume();
    }
    if (this.intervalCheckRealtimeInprogress) {
      if (!resume) {
        this.intervalCheckRealtimeInprogress.pause();
      } else {
        this.intervalCheckRealtimeInprogress.resume();
      }
    }
  }

  onCommentTypeChange({ isDisplayComment, commentType }: { isDisplayComment: boolean, commentType: any }, index): void {
    const value = !isDisplayComment ? 0 : 1;
    this.onToggleDisplayComment(value, index);
  }

  onChangeTimerState(state: number, noEmit?: boolean): void {
    if (!!this.dialogOpened || !!this.realtimeTreatmentAPILoading) {
      if (this.intervalTimer) this.intervalTimer.pause();
      if (this.intervalTimerChannels) this.intervalTimerChannels.pause();
      if (this.commentTimer) this.commentTimer.pause();
      if (this.wellTokenIntervalTimer) this.wellTokenIntervalTimer.pause();
      if (!noEmit) this.timerStateChange.emit(state);
    } else {
      if (state == TimerState.paused) {
        if (this.intervalTimer) this.intervalTimer.pause();
        if (this.intervalTimerChannels) this.intervalTimerChannels.pause();
        if (this.commentTimer) this.commentTimer.pause();
        if (this.wellTokenIntervalTimer) this.wellTokenIntervalTimer.pause();
      } else if (state == TimerState.resumed) {
        if (this.intervalTimer) this.intervalTimer.resume();
        if (this.intervalTimerChannels) this.intervalTimerChannels.resume();
        if (this.commentTimer) this.commentTimer.resume();
        if (this.wellTokenIntervalTimer) this.wellTokenIntervalTimer.resume();
      }
      if (!noEmit) this.timerStateChange.emit(state);
    }
  }

  onDestroyInterval(): void {
    if (this.intervalTimer) this.intervalTimer.stop();
    if (this.intervalTimerChannels) this.intervalTimerChannels.stop();
    if (this.commentTimer) this.commentTimer.stop();
    if (this.intervalCheckRealtimeInprogress) {
      this.intervalCheckRealtimeInprogress.stop();
    }
  }

  runIntervalCheckRealtimeInprogress() {
    this.ngZone.runOutsideAngular(() => {
      this.intervalCheckRealtimeInprogress = new IntervalTimer(
        () => {
          this.subscriptions.push(
            this.autoReloadNextTreatment(this.queryParams.wellId, this.queryParams.treatmentId).subscribe()
          );
        }, INTERVAL_CHECK_WELL_INPROGRESS
      );
    });
  }

  onToggleDataPanel(value?: boolean) {
    this.renderDataPanel = isNil(value) ? !this.renderDataPanel : value;
  }

  getDataPanelItems(channelSetting: IChannelSettingModel, inputData: IInputDataMultiFlow): IChannelSettingItemModel[] {
    let result = [];
    if (inputData && !isEmpty(inputData)) {
      const dataFlows = [INPUT_DATA_KEY.realtimeData, INPUT_DATA_KEY.fracproData];
      dataFlows.forEach(dataType => {
        if (inputData[dataType] && !isEmpty(inputData[dataType])) {
          const prefixChannelName = this.channelSelectionService.getPrefixChannelByDataType(dataType);
          const channelSettingsByDataType = this.channelSelectionService.filterChannelsByPrefixStr(channelSetting, prefixChannelName);
          const lastData = this.baseChartService.getLastDataEachChannel(channelSettingsByDataType, inputData[dataType][0]);
          if (!isEmpty(lastData)) {
            result = result.concat(lastData);
          }
        }
      });
    }
    return result;
  }

  getOffsetChannelDataPanel(offsetChannelSettings: IChannelSettingModel, offsetInputData: IInputDataMultiFlow[]): IChannelSettingItemModel[] {
    const result = [];
    const offsetChannels = this.channelSelectionService.getListChannels(offsetChannelSettings, true);
    for (const channelItem of offsetChannels) {
      // do NOT add BD to data panel
      if (channelItem.isBourdetDer) continue;
      const inputData = offsetInputData.find(x => Helper.findMultiProp(x, channelItem, TreatmentService.COMPARE_CHANNEL_PROP));
      if (inputData && !isEmpty(inputData.realtimeData)) {
        const mapValue = this.baseChartService.getLastValueByChannel(channelItem, inputData.realtimeData[0]);
        channelItem.channelValue = mapValue.channelValue;
        channelItem.firstData = mapValue.firstData;
        channelItem.lastData = mapValue.lastData;
      }
      result.push(channelItem);
    }
    return result;
  }

  getGridDataItems(listFracProChannels, fracproData: IInputDataChart, realtimeData: IInputDataChart, predictedCNames?: string[]) {
    const gridData = this.realtimeChartService.getFracproGridData(listFracProChannels);
    if (gridData) {
      this.realtimeChartService.setChannelValueGridData(gridData, fracproData, realtimeData, predictedCNames);
    }
    return gridData;
  }

  onSelectFlowpath(data) {
    if (data) {
      this.treatmentPlot.selectFlowpathHandler(data);
    }
  }

  navigateRenameChannel() {
    this.router.navigate(['pages/renameChannel'], {
      queryParams: { wellId: this.queryParams.wellId, treatmentId: this.queryParams.treatmentId }
    });
  }

  isNumberValue(value) {
    if (isNumber(value)) {
      return true;
    }
    return false;
  }

  isTrimValue(value) {
    return value.trim();
  }

  getTreatmentComments(wellId, treatmentId) {
    return this.treatmentService.getListComments(wellId, treatmentId).pipe(map(response => {
      if (response && response.result && !isEmpty(response.result)) {
        return response.result;
      }
      return [];
    }));
  }

  private loadTreatmentComments(wellId, treatmentId): void {
    if (this.treatmentInfo && this.treatmentInfo.number === -10) return;
    this.subscriptions.push(
      this.getTreatmentComments(wellId, treatmentId)
        .subscribe(
          treatmentComments => {
            if (!isEmpty(treatmentComments)) {
              this.listTreatmentComments = treatmentComments;
            }
          },
          err => err
        )
    );
  }

  checkIsTreatmentInProgress(wellId: number, treatmentId: number): Observable<boolean> {
    return this.treatmentService.getTreatmentDetailWebApi(wellId, treatmentId).pipe(map(res => {
      if (res && res.result) {
        return res.result.inProgress;
      }
      return res;
    }));
  }

  findNextTreatment(wellId: number, currentTreatmentId: number): Observable<{ id: number; treatmentNumber: number }> {
    return this.treatmentService.getListTreatment(wellId).pipe(map(res => {
      if (res && res.result && res.result.length > 1) {
        // Sort by treatment number
        const listTreatment = orderBy(res.result, item => item.treatmentNumber);
        const currentIndex = listTreatment.findIndex(item => item.id === currentTreatmentId * 1);
        const nextTreatment = listTreatment[currentIndex + 1];
        return nextTreatment;
      }
      return;
    }));
  }

  autoReloadNextTreatment(wellId: number, curTreatmentId: number) {
    return this.checkIsTreatmentInProgress(wellId, curTreatmentId).pipe(flatMap(isInProgress => {
      if (!isInProgress) {
        return this.findNextTreatment(wellId, curTreatmentId);
      } else {
        return of(null);
      }
    }))
      .pipe(flatMap(nextTreatment => {
        if (nextTreatment && nextTreatment.id) {
          this.checkIsTreatmentInProgress(wellId, nextTreatment.id).toPromise().then(isInProgress => {
            if (isInProgress) {
              // reload next treatment
              this.router.navigate(['/pages/treatments/realtime', nextTreatment.id], {
                queryParams: { wellId, treatmentNumber: nextTreatment.treatmentNumber, }
              });
            }
          });
        }
        return of(null);
      }));
  }

  checkIsDataPanel2Col(dataPanelRef: ElementRef) {
    if (dataPanelRef && dataPanelRef.nativeElement && !isEmpty(dataPanelRef.nativeElement.children)) {
      const scrollHeight = dataPanelRef.nativeElement.children[0].scrollHeight;
      return scrollHeight > 440;
    }
    return false;
  }

  getUnitConveter(measureType: string, curUnit: string): string {
    if (isNil(measureType) || !measureType.length) return curUnit;
    else return this.unitSystemService.getUnit(measureType, undefined, curUnit);
  }

  convertUnit(measureType: string, value, decimal: number): number | string {
    return this.unitSystemService.getValueConvert(measureType, value, decimal);
  }

  @HostListener('window:visibilitychange', ['$event'])
  onVisibilityChange(event) {
    if (document.hidden === true && document.visibilityState === 'hidden') {
      this.onChangeTimerState(TimerState.paused, true);
    } else if (document.hidden === false && document.visibilityState === 'visible') {
      this.onChangeTimerState(TimerState.resumed, true);
    }
  }

}
